module.exports = __webpack_public_path__ + "img/servicios_salas.3a57a973.jpg";